const config = {
  name: "lanier-islands",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // Cancellation not allowed
    cancelDaysBefore: 999,
    cancelTime: "00:00",
    cancelTimeOptions: [],
    // Start time offset from 5 pm, i.e. 5 pm
    startOffsetHrs: 17,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 60
  }
}
export default config
